import AbstractComponent from "./abstract-component";

class HeaderAltText extends AbstractComponent {
  render() {
    const {data: text, options: {color}} = this;
    return {
      text,
      color
    }
  }

  getDefaultOptions() {
    return {
      color: '#585394'
    }
  }
}

export default HeaderAltText.asFunction();
